import React from 'react';
import { Box } from '@mui/material';
import ListingFlats from '../ListingFlats';

const SearchFlats: React.FC = () => {
  return (
    <Box>
      <ListingFlats />
    </Box>
  );
};

export default SearchFlats;
